import React from 'react';
import { styled } from '@mui/material';
import { Colors } from 'library';

export type RBannerVariant = 'warning' | 'info' | 'success';

export interface RBannerConfig {
    message: string;
    variant?: RBannerVariant;
    badge?: string;
    action?: React.ReactNode;
}

interface RBannerProps {
    children: React.ReactNode;
    variant?: RBannerVariant;
    badge?: string;
    action?: React.ReactNode;
}

const variantStyles: Record<RBannerVariant, { bg: string; border: string; badgeBg: string; text: string }> = {
    warning: { bg: Colors.tan, border: Colors.lightWarning, badgeBg: Colors.lightWarning, text: Colors.warning },
    info: { bg: Colors.lightBlue, border: Colors.cloud, badgeBg: Colors.cloud, text: Colors.darkNavy },
    success: { bg: Colors.lightTurq, border: Colors.mediumTurq, badgeBg: Colors.mediumTurq, text: Colors.turquoise },
};

export function RBanner({ children, variant = 'warning', badge, action }: RBannerProps) {
    const styles = variantStyles[variant];

    return (
        <BannerContainer style={{ backgroundColor: styles.bg, borderBottomColor: styles.border }}>
            <Left>
                {badge && <Badge style={{ backgroundColor: styles.badgeBg, color: styles.text }}>{badge}</Badge>}
                <Message style={{ color: styles.text }}>{children}</Message>
            </Left>
            {action && <ActionWrapper>{action}</ActionWrapper>}
        </BannerContainer>
    );
}

const BannerContainer = styled('div')({
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'center',
    padding: '10px 24px',
    borderBottom: '1px solid',
    margin: '-24px -24px 24px -24px',
});

const Left = styled('div')({
    display: 'flex',
    alignItems: 'center',
    gap: 12,
});

const Badge = styled('span')({
    padding: '4px 10px',
    borderRadius: 6,
    fontSize: 12,
    fontWeight: 600,
});

const Message = styled('span')({
    fontSize: 13,
});

const ActionWrapper = styled('div')({
    flexShrink: 0,
});
